import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {PluginListComponent} from './plugin-list.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {EnterEmailComponent} from '../enter-email/enter-email.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatCardModule} from '@angular/material/card';
import {RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module} from 'ng-recaptcha-2';



@NgModule({ declarations: [
        PluginListComponent,
        EnterEmailComponent
    ],
    exports: [
        PluginListComponent,
    ], imports: [CommonModule,
        FormsModule,
        RecaptchaV3Module,
        ReactiveFormsModule,
        MatCardModule,
        MatInputModule,
        MatButtonModule,
        MatDialogModule], providers: [
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LdtRs8UAAAAANaYU-hhW9hI_UoITvAP7W-gsrYz' },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class PluginListModule { }
